import locale from "localization";
import styles from "../cash-noncash.module.scss";
import { Title } from "components/commons";
import { cashTransactionMapper } from "./cash-transactions.mapper";
import { cashTransactionColumn } from "./cash-transactions-column";
import DataTableV2 from "components/commons/data-table/data-table-v2";
import { initialShiftRecordFilterState } from "modules/records/shift-records/shift-records-filter.state";
import useDataTable from "hooks/useDataTable";
import { useMemo } from "react";
import { isArray, sortBy } from "lodash";

const ShiftDetailsCash = ({ shift }) => {
  const transactionsItemDetails = useMemo(() => {
    const result = [];
    Object.entries(shift.transactionItem).forEach(([key, productTransaction]) => {
      if (!key.toLowerCase().includes("item") && isArray(productTransaction)) {
        result.push(...productTransaction.filter((t) => !t.transaction.adjustmentType));
      }
    });

    return result;
  }, [shift.transactionItem]);

  const sortCashTransactions = (items) => {
    const result = items;
    return sortBy(result, ["name", "pumpNumber"]);
  };

  // Enrich cash transactions with formula data
  const enrichedCashTransactions = useMemo(() => {
    const fuelItems = sortCashTransactions(
      (shift?.transactionPaymentMethod.cash || []).filter((item) => item.type === "fuel"),
    );
    const nonFuelItems = sortCashTransactions(
      (shift?.transactionPaymentMethod.cash || []).filter((item) => item.type !== "fuel"),
    );

    const result = [...fuelItems, ...nonFuelItems];

    return result;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shift?.transactionPaymentMethod.cash, transactionsItemDetails]);

  const { table } = useDataTable({
    value: enrichedCashTransactions,
    filter: { initialState: initialShiftRecordFilterState(), mapper: (data) => data },
    table: {
      key: "cash",
      name: "cashTransactions",
      mapper: (val) =>
        cashTransactionMapper({
          val,
          transactionsItemDetails,
        }),
      columns: cashTransactionColumn,
    },
  });

  return (
    <>
      <Title small black>
        {locale.cashTransactions}
      </Title>
      <div className={styles.spacer10} />
      <div className={styles.tableContainer}>
        <DataTableV2 {...table} hideNoSearchResultRender tableVersion="v2" hidePagination />
      </div>
      <div className={styles.spacer50} />
    </>
  );
};

export default ShiftDetailsCash;
